import "core-js/modules/es.regexp.exec.js";
import React, { lazy, Suspense } from 'react';
import { Show, TrackingFunnelProvider, ErrorNamespaceProvider, BlockingErrorBoundary } from '@edreamsodigeo/frontend-core';
const AltFunnel = /*#__PURE__*/lazy(() => import(/* webpackChunkName: "altfunnel" */
/* webpackPrefetch: true */
'./AlternativesFunnel'));
const alternativesRegex = /\/travel\/alternatives\//;
export function AlternativesFunnel() {
  return /*#__PURE__*/React.createElement(ErrorNamespaceProvider, {
    namespace: "shell_funnel_alternatives"
  }, /*#__PURE__*/React.createElement(BlockingErrorBoundary, {
    name: "funnel_alternatives"
  }, /*#__PURE__*/React.createElement(Show, {
    when: alternativesRegex.test(window.location.href)
  }, /*#__PURE__*/React.createElement(TrackingFunnelProvider, {
    funnel: "alternatives"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: null
  }, /*#__PURE__*/React.createElement(AltFunnel, null))))));
}